<template>
  <v-container class="fill-height bg_btn_soft_gradient" fluid>
    <v-row justify="center" align="center">
      <v-col cols="12" sm="10" md="10">
        <!-- <v-card> -->

        <v-tabs
          v-model="currentItem"
          color="#0E62ED"
          height="60"
          light
          grow
          class="Border"
          :show-arrows="mobile"
          center-active
        >
          <v-tab
            v-for="(item, index) in tabs"
            :key="item.title"
            :style="currentItem == index ? 'background-color:#D6E5FD' : ''"
          >
            <v-avatar tile size="36" class="mr-2">
              <v-img :src="item.icon"></v-img>
            </v-avatar>
            <h2>{{ item.title }}</h2>
          </v-tab>
        </v-tabs>
        <v-card class="mt-10">
          <v-tabs-items v-model="currentItem">
            <v-tab-item>
              <Tab1 />
            </v-tab-item>
            <v-tab-item>
              <Tab2 @validate="submitDetail" />
            </v-tab-item>
            <v-tab-item>
              <Tab3 />
            </v-tab-item>
          </v-tabs-items>
        </v-card>
        <!-- </v-card> -->
        <v-card-actions class="pa-0 mt-10" v-if="!mobile">
          <v-btn
            large
            color="primary"
            width="130px"
            outlined
            @click="currentItem -= 1"
            :disabled="currentItem == 0"
          >
            <h4 class="mt-1">ย้อนกลับ</h4>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            v-if="currentItem != 2"
            large
            width="130px"
            color="primary"
            @click="currentItem === 2 ? (currentItem = 0) : (currentItem += 1)"
          >
            <h4 class="mt-1">ขั้นตอนต่อไป</h4>
          </v-btn>
          <v-btn
            :loading="btn_loading"
            width="130px"
            large
            v-if="currentItem == 2 && !read_mode"
            color="primary"
            @click="validateDetail"
          >
            <h4 class="mt-1">บันทึก</h4>
          </v-btn>
        </v-card-actions>
        <v-card-actions class="pa-0 mt-10" v-if="mobile">
          <v-row>
            <v-col cols="12" class="pt-0">
              <v-btn
                large
                block
                color="primary"
                width="130px"
                outlined
                @click="currentItem -= 1"
                :disabled="currentItem == 0"
              >
                <h4 class="mt-1">ย้อนกลับ</h4>
              </v-btn>
            </v-col>
            <v-col cols="12" class="pt-0" v-if="currentItem != 2">
              <v-btn
                v-if="currentItem != 2"
                large
                block
                width="130px"
                color="primary"
                @click="
                  currentItem === 2 ? (currentItem = 0) : (currentItem += 1)
                "
              >
                <h4 class="mt-1">ขั้นตอนต่อไป</h4>
              </v-btn>
            </v-col>

            <v-col cols="12" class="py-0" v-if="currentItem == 2 && !read_mode">
              <v-btn
                :loading="btn_loading"
                width="130px"
                large
                block
                color="primary"
                @click="validateDetail"
              >
                <h4 class="mt-1">บันทึก</h4>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import Tab1 from "./WordTab1";
import Tab2 from "./WordTab2";
import Tab3 from "./WordTab3";
export default {
  components: {
    Tab1,
    Tab2,
    Tab3,
  },
  data() {
    return {
      mode: "detail",
      currentItem: 0,
      tabs: [
        { title: "เลือกภาษา", icon: require("@/assets/icon/translate.png") },
        {
          title: "กรอกข้อมูลคำทับศัพท์",
          icon: require("@/assets/icon/form.svg"),
        },
        {
          title: "แสดงตัวอย่าง",
          icon: require("@/assets/icon/preview.svg"),
        },
      ],
      form: null,
      read_mode: false,
      goTab2: false,
    };
  },
  computed: {
    mobile() {
      if (
        this.$vuetify.breakpoint.width >= 320 &&
        this.$vuetify.breakpoint.width < 768
      ) {
        return true;
      } else {
        return false;
      }
    },
    tablet() {
      if (
        this.$vuetify.breakpoint.width >= 768 &&
        this.$vuetify.breakpoint.width < 1440
      ) {
        return true;
      } else {
        return false;
      }
    },
    desktop() {
      if (this.$vuetify.breakpoint.width >= 1440) {
        return true;
      } else {
        return false;
      }
    },
    btn_loading() {
      return this.$store.state.moduleCreateEditWord.btn_loading;
    },
    // read_mode() {
    //   return this.$store.state.moduleCreateEditWord.createMode == "read"
    //     ? true
    //     : false;
    // },
    current_mode() {
      return this.$route.params.mode;
    },
  },
  watch: {
    current_mode(val) {
      if (val == "create") {
        window.location.reload();
      }
    },
    currentItem(val) {
      if (val == 1) {
        this.goTab2 = true;
      }
    },
  },

  created() {
    const module_name = "permission_backOffice";
    const func_name = "create_edit_word";
    const redirect = { name: "Dashboard", params: { mode: "all" } };

    switch (this.$route.params.mode) {
      case "create":
        this.mode = "create";
        if (this.$session.get(module_name)) {
          if (this.$session.get(module_name).includes(func_name)) {
            this.initialMethod();
          } else {
            this.$router.push(redirect);
          }
        } else {
          this.$router.push(redirect);
        }
        break;
      case "detail":
        this.mode = "detail";
        this.initialMethod();
        break;
      case "edit":
        this.mode = "edit";
        if (this.$session.get(module_name)) {
          if (this.$session.get(module_name).includes(func_name)) {
            this.initialMethod();
          } else {
            this.$router.push(redirect);
          }
        } else {
          this.$router.push(redirect);
        }
        break;
      default:
        this.$router.push({ name: "Dashboard", params: { mode: "all" } });
        break;
    }
  },
  methods: {
    initialMethod() {
      this.$store.commit("getMasterData");
      if (!this.$route.query.id) {
        if (this.$store.state.moduleCreateEditWord.createMode != "request") {
          this.$store.commit("clearData");
        }
      } else {
        // mode : read only
        if (this.$route.params.mode == "detail" && this.$route.query.id) {
          this.$store.state.moduleCreateEditWord.createMode == "read";
          this.read_mode = true;
          this.axios
            .get(
              process.env.VUE_APP_API +
                "api/v1/admin/romanlanguage/" +
                this.$route.query.id,
              this.header_token
            )
            .then((res) => {
              if (res.data) {
                var data = res.data;
                this.$store.state.moduleCreateEditWord.created_word = {
                  categoryId: data.categoryId,
                  mean: data.mean,
                  subLanguage: data.subLanguage,
                };
                data.subLanguage.forEach((element) => {
                  var include = this.$store.state.moduleCreateEditWord.selected_language.includes(
                    element.languageId
                  );
                  if (include == false) {
                    this.$store.state.moduleCreateEditWord.selected_language.push(
                      element.languageId
                    );
                  }
                });
              }
            });
          this.currentItem = 2;
        }
      }
    },
    submitDetail(event) {
      this.form = event;
    },
    validateDetail() {
      if (
        this.$store.state.moduleCreateEditWord.selected_language.length == 0
      ) {
        this.currentItem = 0;
        this.$swal.fire({
          icon: "warning",
          title: "กรุณาเลือกอย่างน้อย 1 ภาษา",
          // showConfirmButton: false,
          // timer: 1000,
        });
      } else {
        if (this.goTab2 == false) {
          this.currentItem = 1;
        } else {
          setTimeout(() => {
            if (this.form.validate()) {
              this.save();
            } else {
              this.currentItem = 1;
            }
          }, 200);
        }
      }
    },
    save() {
      if (this.$route.query.id) {
        var data = this.$route.query.id;
        this.$store.commit("editWord", data);
      } else {
        this.$store.commit("createWord");
      }
    },
  },
};
</script>
<style>
.Border {
  /* width: 1200px; */
  height: 60px;
  /* border-radius: 4px; */
  box-shadow: 0px 7px 7px 0px rgba(0, 0, 0, 0.2);
  background-color: #e7e5e5;
}
</style>
